import { h } from 'preact';

import './info_panel.scss';
import * as is from 'utilities/is';
import { BaseAnnotation } from 'rendering/annotations/base_annotation';
import { Panel } from 'rendering/components/panel';
import { ANNOTATION_EVENT } from 'constants/events';
import { COMPOSITION_TYPES, getCompositionInfo } from 'constants/annotations';

export class InfoPanel extends BaseAnnotation {
    onClose = e => {
        this.setState({
            closed: true
        });
        this.eventBus.emit(ANNOTATION_EVENT.HIDE, this.props.id);
    }

    render() {
        const { INFO_PANEL } = COMPOSITION_TYPES;

        return (
            <Panel { ...this.dataAttrs } aria-label="Info Panel" role="dialog" aria-labelledby="info-title" style={ this.getElementStyles() }>
                <span className="info-panel">
                    <button className="close-button" onClick={ this.onClose } style={ this.getElementStyles(INFO_PANEL.CLOSE) }>×</button>
                    { 
                        is.defined(this.options.title) ? 
                            <h1 id="info-title" style={ this.getElementStyles(INFO_PANEL.TITLE) }>{ this.options.title }</h1> :
                            null 
                    }                    
                    { 
                        is.defined(this.options.image) ? 
                            <img src={ this.options.image } style={ this.getElementStyles(INFO_PANEL.IMAGE) }/> :
                            null
                    }
                    <span className="content" style={ this.getElementStyles(INFO_PANEL.CONTENT) }>{ this.contents }</span>
                </span>
            </Panel>
        );
    }

    get dataAttrs() {
        return {
            ...super.dataAttrs,
            'data-closed': this.state.closed
        };
    }

    get contents() {
        return this.props.content || '';
    }

    get defaultState() {
        return {
            closed: false
        }
    }

    static get schemaType() {
        return 'infopanel';
    }

    static get composition() {
        return getCompositionInfo('INFO_PANEL');
    }
}